import { contactFormFieldsTestId } from "../ContactFormFields/constants";
export const preferredMoveInDateTestId = `${contactFormFieldsTestId}-preferredMoveInDate`;
export const workStatusTestId = `${contactFormFieldsTestId}-workStatus`;
export const netMonthlyIncomeTestId = `${contactFormFieldsTestId}-netMonthlyIncome`;
export const householdTypeTestId = `${contactFormFieldsTestId}-householdType`;
